// extracted by mini-css-extract-plugin
export default {"container":"NotificationContainer_container__i2QE2"};